/* eslint-disable @typescript-eslint/no-unused-vars */

import {
  iconColors,
  iconSizes,
} from '@backmarket/design-system/components/Icon/Icon.constant'
import { type IconName, iconNames } from '@backmarket/design-system/icons/icons'
import type { IconColor, IconSize } from '@ds/types/Icon'
import { z } from 'zod'

import type { Equal, ExpectTrue } from '../types/validation'

/* TypeScript */
export type CmsIcon = {
  icon: IconName
  color?: IconColor
  size?: IconSize
}

/* Schemas */
export const IconNameSchema = z.enum(iconNames)

export const IconColorSchema = z.enum(iconColors)

export const IconSizeSchema = z.enum(iconSizes)

export const CmsIconSchema = z.object({
  icon: IconNameSchema,
  color: IconColorSchema.optional(),
  size: IconSizeSchema.optional(),
})

/* Schemas validation */
type TestCmsIcon = ExpectTrue<Equal<CmsIcon, z.infer<typeof CmsIconSchema>>>
